export default __webpack_public_path__ + "6d865f811cb7478325d4b615b32a20ea.svg";